
import { Injectable } from '@angular/core';
import Quill from 'quill';
import { Mention } from 'quill-mention';
 // Register the mention module
Quill.register('modules/mention', Mention);
 // Import Mention Blot


@Injectable({
    providedIn: "root",
})

export class QuillCustomServices {

 mentionUsers = [];

  private getInitials(name: string): string {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return ((parts[0][0] || '') + (parts[parts.length - 1][0] || '')).toUpperCase();
  }

  private normalizeAvatar(user: any): string {
    const raw = user?.photo || user?.image || user?.photo_url || user?.avatar || '';
    if (!raw || typeof raw !== 'string') return '';
    const src = raw.trim();
    if (!src) return '';
    if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('data:')) return src;
    return `data:image/png;base64,${src}`;
  }



  QuillConfigDefault =  {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    //   ['blockquote', 'code-block'],

    //   [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    //   [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    //   [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    //   [{ 'direction': 'rtl' }],                         // text direction

      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    //   [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    //   [{ 'font': [] }],
    //   [{ 'align': [] }],

      ['clean'],                                         // remove formatting button

    //   ['link', 'image', 'video']                         // link and image, video
    ],
    mention: {
      allowedChars: /^[A-Za-z0-9_.\s\-ÅÄÖåäö]*$/,
      mentionDenotationChars: ['@'],
      minChars: 0,
      defaultMenuOrientation: 'bottom',
      fixMentionsToQuill: false,
      positioningStrategy: 'fixed',
      renderItem: (item: any) => {
        const row = document.createElement('div');
        row.className = 'ql-mention-item-row';

        const avatarWrap = document.createElement('span');
        avatarWrap.className = 'ql-mention-avatar';

        if (item?.avatar) {
          const img = document.createElement('img');
          img.className = 'ql-mention-avatar-img';
          img.src = item.avatar;
          img.alt = item.value || 'user';
          img.onerror = () => {
            img.remove();
            avatarWrap.textContent = item?.initials || '';
          };
          avatarWrap.appendChild(img);
        } else {
          avatarWrap.textContent = item?.initials || '';
        }

        const name = document.createElement('span');
        name.className = 'ql-mention-name';
        name.textContent = item?.value || '';

        row.appendChild(avatarWrap);
        row.appendChild(name);
        return row;
      },
      source: (searchTerm: string, renderList: Function) => {
        if (searchTerm.length === 0) {
          renderList(this.mentionUsers, searchTerm);
        } else {
          const q = (searchTerm || '').toLowerCase();
          const matches = this.mentionUsers.filter(user =>
            (user.value || '').toLowerCase().includes(q) ||
            (user.email || '').toLowerCase().includes(q)
          );
          renderList(matches, searchTerm);
        }
      }
    }
  }

  setMentions(data:any){
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.results)
        ? data.results
        : Array.isArray(data?.data)
          ? data.data
          : [];

    this.mentionUsers = list
      .map((user: any) => {
        const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim();
        const value =
          user?.name ||
          user?.full_name ||
          fullName ||
          user?.user_name ||
          user?.username ||
          user?.email ||
          '';

        return {
          value,
          id: user?.id,
          avatar: this.normalizeAvatar(user),
          initials: this.getInitials(value),
          email: user?.email || ''
        };
      })
      .filter((u: any) => !!u.value);

    // console.log( this.mentionUsers )
  }

};
